import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { eventTypes } from '@ers/data';
import Maybe from 'react-maybe';
import { Button, Icon, Spinner, Tooltip, Drop, Typo } from '@ers/ui/';
import { getPersonalDataCity, getPersonalDataLoading } from '@ers/root/App.selectors';
import { sendEvent } from '@ers/root/App.actions';
import { v4 as uuid } from 'uuid';
import { RecommendationTypes } from '@ers/data/';


const Recommendations = ({ applicationId, children, positionName, ...rest }) => {
    const dispatch = useDispatch();
    let show = false;
    const isUserDataLoaded = useSelector(getPersonalDataLoading);
    const city = useSelector(getPersonalDataCity);
    show = isUserDataLoaded;

    const encodeURI = encodeURIComponent(positionName);

    const handleClick = (key) => (e) => {
        let url = null;
        e.preventDefault();
        switch (key) {
            case 'pracuj':
                const utmERecruiter = `utm_source=erecruiter&utm_medium=konto&utm_campaign=konto_er_test`;
                if (city) {
                    url = `https://www.pracuj.pl/praca/${encodeURI};kw/${city};wp?rd=30&${utmERecruiter}`;
                } else {
                    url = `https://www.pracuj.pl/praca/${encodeURI};kw?${utmERecruiter}`;
                }
                dispatch(sendEvent(eventTypes.recommendations, { applicationIds: [applicationId] }));
                break;
            case 'theprotocol':
                const utmTheProtocol= `utm_source=erecruiter&utm_medium=konto&utm_campaign=protocol&utm_term=konto_user_eryk`;
                url = `https://theprotocol.it/?kw=${encodeURI}&${utmTheProtocol}`;
                dispatch(sendEvent(eventTypes.theprotocolRecommendations, { }));
                break;
            default:
                break;
        };
        window.open(url, '_blank');
    };

    return children({ show, handleClick, ...rest });
};

const renderOptions = (handleClick) => {
    return Object.keys(RecommendationTypes).map((key, index) => <div key={index} onClick={handleClick(key)}><Typo.Body>{RecommendationTypes[key]}</Typo.Body></div>);
}


Recommendations.Button = function RecommendationsButton({ show, handleClick, ...rest }) {
    return (
        <Maybe
            of={show}
            either={(
                <Drop trigger={(className, onClick) =>
                    <Button.Primary onClick={onClick} {...rest}>
                        <Icon name="magnifier-white" />
                        Znajdź podobne oferty pracy
                    </Button.Primary>}>
                    {renderOptions(handleClick)}
                </Drop>
            )}
            orElse={<Spinner.Dots {...rest} />}
        />
    );
}

Recommendations.Button.propTypes = {
    handleClick: PropTypes.func.isRequired,
    show: PropTypes.bool
};

Recommendations.Button.defaultProps = {
    show: false
};

Recommendations.Icon = function RecommendationsIcon({ show, handleClick, ...rest }) {
    return (
        <Maybe
            of={show}
            either={(
                <Drop trigger={(className, onClick) =>
                    <Tooltip tip="Znajdź podobne oferty pracy" id={uuid()}>
                        <Icon name="magnifier" onClick={onClick} {...rest} />
                    </Tooltip>}
                align="center">
                    {renderOptions(handleClick)}
                </Drop>
            )}
            orElse={<Spinner.Dots {...rest} />}
        />
    );
}

Recommendations.Icon.propTypes = {
    handleClick: PropTypes.func.isRequired,
    show: PropTypes.bool
};

Recommendations.Icon.defaultProps = {
    show: false
};

export default Recommendations;
